<template>
  <f7-page class="page-bot-view" @page:init="pageMounted" @page:afterin="pageAfterIn" @page:afterout="pageAfterOut">
    <f7-navbar :sliding="false">
      <f7-nav-left back-link="Trở lại"></f7-nav-left>
      <f7-nav-title sliding>{{ fullname }}</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:ellipsis_vertical" popover-open=".popover-menu"></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="botType !== 'telegram_forwarder' && !_.isEmpty(connectCodeCom)">
      <f7-block inset strong>
        <h3 class="text-align-center">MÃ LIÊN KẾT BOT CỦA BẠN LÀ</h3>
        <div class="list form-list no-margin margin-bottom-half">
          <ul>
            <li class="item-content item-input item-input-with-value">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" class="input-with-value" @focus="$event.target.select()" :value="connectCodeCom"/>
                </div>
              </div>
              <div class="item-media">
                <button type="button" @click.prevent="copyCode" class="button button-44 text-color-theme margin-half">
                  <f7-icon f7="doc_on_doc"></f7-icon>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </f7-block>
      <f7-block inset strong v-if="config.allow_forward_room && !_.isEmpty(forwardCode)">
        <h3 class="text-align-center ">MÃ LIÊN KẾT PHÒNG TRẢ SỐ DƯ</h3>
        <div class="list form-list no-margin margin-bottom-half">
          <ul>
            <li class="item-content item-input item-input-with-value">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="text" class="input-with-value" @focus="$event.target.select()" :value="forwardCode"/>
                </div>
              </div>
              <div class="item-media">
                <button type="button" @click.prevent="copyClipboard(forwardCode)" class="button button-44 text-color-theme margin-half">
                  <f7-icon f7="doc_on_doc"></f7-icon>
                </button>
              </div>
            </li>
          </ul>
        </div>
      </f7-block>
    </template>
    <template v-else>
      <template v-if="tab_active === 'config'">
        <template v-if="botType !== 'telegram_forwarder'">
          <f7-list inset inline-labels>
            <f7-list-input label="Cú pháp" type="select" @input="config.play_style = $event.target.value">
              <f7-icon slot="media" ios="f7:gear_alt" color="crimson"></f7-icon>
              <option v-for="(item, idx) in (_.find(play_styles, {region: config.region})).items" :key="`play_${idx}`" :value="item.value" :selected="config.play_style === item.value">
                {{ item.label }}
              </option>
            </f7-list-input>
          </f7-list>
          <f7-list inset inline-labels v-if="user_info.server_region !== 'hanoi'">
            <f7-list-item title="Miền Nam">
              <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
              <f7-toggle slot="after" :checked="config.allow_active_bot.indexOf('mn') >= 0" @toggle:change="toggleActive('mn')"></f7-toggle>
            </f7-list-item>
            <f7-list-item title="Miền Trung">
              <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
              <f7-toggle slot="after" :checked="config.allow_active_bot.indexOf('mt') >= 0" @toggle:change="toggleActive('mt')"></f7-toggle>
            </f7-list-item>
            <f7-list-item title="Miền Bắc">
              <f7-icon slot="media" ios="f7:cube" color="crimson"></f7-icon>
              <f7-toggle slot="after" :checked="config.allow_active_bot.indexOf('mb') >= 0" @toggle:change="toggleActive('mb')"></f7-toggle>
            </f7-list-item>
          </f7-list>
        </template>
        <f7-list inset inline-labels>
          <f7-list-item title="Nhận tin tự động">
            <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="config.allow_convert_temp_messages.length > 0" @toggle:change="toggleAutoConvert"></f7-toggle>
          </f7-list-item>
        </f7-list>
        <f7-list inset inline-labels>
          <f7-list-item title="Nhận trong chuẩn">
            <f7-icon slot="media" ios="f7:ant" color="crimson"></f7-icon>
            <f7-toggle slot="after" :checked="config.allow_overpoint_limitation.length > 0" @toggle:change="toggleOverpoint"></f7-toggle>
          </f7-list-item>
        </f7-list>
        <template v-if="!_.isEmpty(config) && config.allow_active_bot.length > 0 && config.allow_overpoint_limitation.length > 0">
          <f7-block-title class="mt-2">CÀI ĐẶT CHUẨN NHẬN SỐ</f7-block-title>
          <f7-block inset v-if="config.allow_active_bot.length > 1">
            <f7-segmented raised>
              <f7-button v-if="config.allow_active_bot.indexOf('mn') >= 0" :active="tab_overpoint_active === 'mn'" @click.prevent="tab_overpoint_active = 'mn', getBlockNumbers()">
                M.NAM
              </f7-button>
              <f7-button v-if="config.allow_active_bot.indexOf('mt') >= 0" :active="tab_overpoint_active === 'mt'" @click.prevent="tab_overpoint_active = 'mt', getBlockNumbers()">
                M.TRUNG
              </f7-button>
              <f7-button v-if="config.allow_active_bot.indexOf('mb') >= 0" :active="tab_overpoint_active === 'mb'" @click.prevent="tab_overpoint_active = 'mb', getBlockNumbers()">
                M.BẮC
              </f7-button>
            </f7-segmented>
          </f7-block>
          <template v-if="tab_overpoint_active === 'mn'">
            <ConfigOverPointNgheAn v-if="config.play_style.indexOf('_ngan') >= 0" :region="'mn'" :key="`mn-ovp-ngan`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointNgheAn>
            <ConfigOverPointBmt v-else-if="config.play_style.indexOf('_buonme') >= 0" :region="'mn'" :key="`mn-ovp-buonme`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointBmt>
            <ConfigOverPointHanoi v-else-if="config.play_style.indexOf('_hanoi') >= 0" :region="'mn'" :key="`mn-ovp-hanoi`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointHanoi>
            <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mn'" :key="`mn-ovp-default`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointDefault>
          </template>
          <template v-else-if="tab_overpoint_active === 'mt'">
            <ConfigOverPointNgheAn v-if="config.play_style.indexOf('_ngan') >= 0" :region="'mt'" :key="`mt-ovp-ngan`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointNgheAn>
            <ConfigOverPointBmt v-else-if="config.play_style.indexOf('_buonme') >= 0" :region="'mt'" :key="`mt-ovp-buonme`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointBmt>
            <ConfigOverPointHanoi v-else-if="config.play_style.indexOf('_hanoi') >= 0" :region="'mt'" :key="`mt-ovp-hanoi`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointHanoi>
            <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mt'" :key="`mt-ovp-default`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointDefault>
          </template>
          <template v-else-if="tab_overpoint_active === 'mb'">
            <ConfigOverPointNgheAn v-if="config.play_style.indexOf('_ngan') >= 0" :region="'mb'" :key="`mb-ovp-ngan`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointNgheAn>
            <ConfigOverPointBmt v-else-if="config.play_style.indexOf('_buonme') >= 0" :region="'mb'" :key="`mb-ovp-buonme`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointBmt>
            <ConfigOverPointHanoi v-else-if="config.play_style.indexOf('_hanoi') >= 0" :region="'mb'" :key="`mb-ovp-hanoi`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointHanoi>
            <ConfigOverPointDefault v-else :enable-block-number="true" :region="'mb'" :key="`mb-ovp-default`" :play-style="config.play_style" :cust-id="customerId" v-on:updatedConfig="updateConfig" ref="configOverPoint"></ConfigOverPointDefault>
          </template>
        </template>
        <f7-block v-else inset class="mt-1">
          <f7-button fill color="primary" @click.prevent="updateConfig">LƯU CẤU HÌNH</f7-button>
        </f7-block>
      </template>
      <template v-else>
        <template v-if="botType === 'telegram_free_text'">
          <div class="fixed-top">
            <f7-block inset class="mt-0 pt-1">
              <f7-segmented raised>
                <f7-button :class="{'p-0': freetextPlayStyles[freetext_tab].length > 1}" :active="freetext_tab === 'mn'" @click.prevent="freetext_tab = 'mn', freetextPlayStyleSelected = freetextPlayStyles[freetext_tab][0].value">
                  MN
                </f7-button>
                <f7-button :class="{'p-0': freetextPlayStyles[freetext_tab].length > 1}" :active="freetext_tab === 'mt'" @click.prevent="freetext_tab = 'mt', freetextPlayStyleSelected = freetextPlayStyles[freetext_tab][0].value">
                  MT
                </f7-button>
                <f7-button :class="{'p-0': freetextPlayStyles[freetext_tab].length > 1}" :active="freetext_tab === 'mb'" @click.prevent="freetext_tab = 'mb', freetextPlayStyleSelected = freetextPlayStyles[freetext_tab][0].value">
                  MB
                </f7-button>
              </f7-segmented>
              <f7-segmented raised strong class="mt-1" v-if="freetextPlayStyles[freetext_tab].length > 1">
                <f7-button class="p-0" v-for="(item, idx) in freetextPlayStyles[freetext_tab]" :key="`b${idx}`" :active="item.value === freetextPlayStyleSelected" @click.prevent="freetextPlayStyleSelected = item.value">
                  {{ item.label }}
                </f7-button>
              </f7-segmented>
              <f7-row class="pt-1">
                <f7-col>
                  <a href="#" @click.prevent="getTempMessages(), intervalSecond = 10">Làm mới ({{ intervalSecond }})</a>
                </f7-col>
                <f7-col class="text-align-right">
                  <a href="#" @click.prevent="goToCreateMessage()">
                    <f7-chip :text="`Xử lý Tin (${checkedItems.length})`" color="red" class="fs-15 btn-shadow"></f7-chip>
                  </a>
                </f7-col>
              </f7-row>
            </f7-block>
          </div>
          <div class="after-fixed-top">
            <f7-block inset class="mt-0">
              <template v-if="messages.length">
                <div class="data-table sm bordered card mb-1" v-for="(item, idx) in _.orderBy(messages, ['id'], ['asc'])" :key="idx">
                  <table>
                    <tbody>
                    <tr :class="{'bg-color-seen': item.modified_status}" @click.prevent="toggleCheckbox(item)" :id="`ftm_${item.ordinal}`">
                      <td>
                        <s v-if="item.status === 1"> <strong>#{{ idx + 1 }}</strong> {{ item.content_original }}</s>
                        <template v-else>
                          <strong>#{{ idx + 1 }}</strong> {{ item.content_original }}
                        </template>
                      </td>
                      <td style="width:50px" class="text-align-center">
                        <f7-checkbox :disabled="item.modified_status === 1" :checked="_.findIndex(checkedItems, {id: item.id}) >= 0"></f7-checkbox>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
              <p v-else class="text-align-center">Chưa có tin nhắn!</p>
            </f7-block>
          </div>
        </template>
        <template v-else>
          <f7-block inset class="mt-0 mb-2" v-if="user_info.server_region !== 'hanoi'">
            <f7-segmented raised>
              <f7-button v-if="config.allow_active_bot.indexOf('mn') >= 0" :active="tab_active === 'mn'" @click.prevent="tab_active = 'mn'">
                MN
              </f7-button>
              <f7-button v-if="config.allow_active_bot.indexOf('mt') >= 0" :active="tab_active === 'mt'" @click.prevent="tab_active = 'mt'">
                MT
              </f7-button>
              <f7-button v-if="config.allow_active_bot.indexOf('mb') >= 0" :active="tab_active === 'mb'" @click.prevent="tab_active = 'mb'">
                MB
              </f7-button>
            </f7-segmented>
          </f7-block>
          <f7-block inset class="mt-1">
            <p class="text-align-right mt-1 mb-0">
              <a href="#" @click.prevent="getTempMessages(), intervalSecond = 10">Làm mới ({{ intervalSecond }})</a>
            </p>
            <template v-if="filteredMessages.length">
              <div class="data-table sm bordered card mb-1" v-for="(item, idx) in filteredMessages" :key="idx">
                <table>
                  <tbody>
                  <tr>
                    <td>
                      <s v-if="item.status === 1"> <strong>#{{ item.ordinal }}</strong> {{ item.content_original }}</s>
                      <template v-else>
                        <strong>#{{ item.ordinal }}</strong> {{ item.content_original }}
                      </template>
                    </td>
                  </tr>
                  <tr v-if="item.status !== 1 && botType !== 'telegram_forwarder'">
                    <td class="text-color-red pt-05 pb-05">
                      <f7-row>
                        <f7-col>
                          <span v-if="item.status === 0" class="text-color-red">Chưa xử lý</span>
                          <span v-else-if="item.status === 1" class="text-color-black">Đã hủy</span>
                          <span v-else-if="item.status === 2" class="text-color-green">Đã xử lý</span>
                        </f7-col>
                        <f7-col class="text-align-right">
                          <a class="text-color-blue mr-1"
                             v-if="item.status === 0"
                             @click.prevent="acceptMessage(item)">[NHẬN TIN]
                          </a>
                          <a class="text-color-red"
                             @click.prevent="denyMessage(item)">[XÓA]
                          </a>
                        </f7-col>
                      </f7-row>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </template>
            <p v-else class="text-align-center">Chưa có tin nhắn!!</p>
          </f7-block>
        </template>
      </template>
    </template>
    <f7-popover class="popover-menu">
      <f7-list>
        <f7-list-item link popover-close
                      v-if="tab_active !== 'config' && botType === 'telegram' && _.isEmpty(connectCodeCom)"
                      @click.prevent="tab_active = 'config', getBlockNumbers()"
                      title="Cấu hình">
          <f7-icon slot="media" f7="gear_alt"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close
                      v-if="botType !== 'telegram_forwarder' && _.isEmpty(connectCodeCom)"
                      @click.prevent="generateBotRoomCode"
                      title="Tạo lại mã liên kết">
          <f7-icon slot="media" f7="qrcode"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close
                      v-if="tab_active === 'config' && botType !== 'telegram_forwarder' && _.isEmpty(connectCodeCom)"
                      @click.prevent="tab_active = config.allow_active_bot.indexOf('mn') >= 0 ? 'mn' : (config.allow_active_bot.indexOf('mt') >= 0 ? 'mt' : 'mb')"
                      title="Xem tin nhắn">
          <f7-icon slot="media" f7="bubble_left_bubble_right"></f7-icon>
        </f7-list-item>
        <f7-list-item link popover-close
                      @click.prevent="removeBot"
                      title="Xóa Bot">
          <f7-icon slot="media" f7="trash"></f7-icon>
        </f7-list-item>
      </f7-list>
    </f7-popover>
  </f7-page>
</template>
<style scoped>
.fs-15{
  font-size: 15px !important;
}
.btn-shadow{
  box-shadow: var(--f7-button-raised-box-shadow);
}
.fixed-top {
  position : fixed;
  top      : calc(var(--f7-navbar-height));
  height   : 122px;
  width    : 100%;
  left     : 0;
  z-index  : 109;
  background: linear-gradient(45deg, var(--fimobile-page-bg-2) 0%, var(--fimobile-page-bg-1) 100%);
}
.after-fixed-top{
  padding-top: 122px;
}
.bg-color-seen{
  background: #5ECAFF !important;
}
</style>
<script>
import { mapState } from 'vuex';
import moment from "moment-timezone";
import ConfigOverPointDefault from "@/pages/Message/components/ConfigOverPointDefault.vue";
import ConfigOverPointBmt from "@/pages/Message/components/ConfigOverPointBmt.vue";
import ConfigOverPointNgheAn from "@/pages/Message/components/ConfigOverPointNgheAn.vue";
import ConfigOverPointHanoi from "@/pages/Message/components/ConfigOverPointHanoi.vue";

export default {
  components: { ConfigOverPointHanoi, ConfigOverPointNgheAn, ConfigOverPointBmt, ConfigOverPointDefault },
  props: {
    customerId: Number,
    chatRoomId: Number,
    fullname: String,
    connectCode: String,
    forwardCode: String,
    botType: String,
    config: Object
  },
  data() {
    return {
      connect_code: '',
      freetext_tab: 'mn',
      tab_active: 'mn',
      tab_overpoint_active: 'mn',
      messages: [],
      checkedItems: [],
      regions: [
        {
          label: 'Miền Nam',
          value: 'mn'
        },
        {
          label: 'Miền Bắc',
          value: 'mb'
        },
        {
          label: 'Miền Trung',
          value: 'mt'
        }
      ],
      play_styles: [
        {
          region: 'mn',
          items: [
            {
              label: 'Sài Gòn',
              value: 'default'
            },
            {
              label: 'Miền Tây',
              value: 'mn_mtay'
            }
          ]
        },
        {
          region: 'mb',
          items: [
            {
              label: 'Sài Gòn',
              value: 'default'
            },
            {
              label: 'Miền Tây',
              value: 'mn_mtay'
            }
          ]
        },
        {
          region: 'mt',
          items: [
            {
              label: 'Sài Gòn',
              value: 'default'
            },
            {
              label: 'Miền Tây',
              value: 'mn_mtay'
            }
          ]
        }
      ],
      intervalMessages: null,
      intervalSecond: 10,
      lastModifiedOrdinal: 0,
      isGoToLast: false,
      freetextPlayStyles: {
        mn: [],
        mb: [],
        mt: []
      },
      freetextPlayStyleSelected: 'default'
    }
  },
  computed: {
    ...mapState(['customers', 'selected_customer', 'user_info']),
    filteredMessages(){
      return _.filter(this.messages, {region: this.tab_active});
    },
    freetextMessages() {
      return this.messages;
    },
    connectCodeCom(){
      return !!this.connect_code ? this.connect_code : this.connectCode;
    }
  },
  methods: {
    getTempMessages(){
      let self = this;

      self.$store.dispatch('getChatRoomTempMessages', {room_id: self.chatRoomId, draw_date: moment().format('YYYY-MM-DD')}).then((res) => {
        self.messages = res.data;
        self._.each(self._.orderBy(self.messages, ['id'], ['asc']), (item) => {
          if (item.modified_status){
            self.lastModifiedOrdinal = item.ordinal;
          }
        });
        setTimeout(function(){
          if (!self.isGoToLast && self.botType === 'telegram_free_text'){
            self.isGoToLast = true;
            if(document.getElementById(`ftm_${self.lastModifiedOrdinal}`)){
              document.getElementById(`ftm_${self.lastModifiedOrdinal}`).scrollMarginTop = 10;
              document.getElementById(`ftm_${self.lastModifiedOrdinal}`).scrollIntoView({behavior: 'smooth'})
            }
          }
        }, 200);
      }).catch((err) => {
        this.$f7.dialog.close();
        this.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    updateConfig() {
      let self = this;
      self.$f7.dialog.preloader();

      self.$store.dispatch('updateChatRoomConfig', self.config).then(() => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert('Đã cập nhật', 'THÀNH CÔNG!');
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    removeTempMessages(){
      this.$f7.dialog.alert('Đang phát triển...', 'LỖI!');
    },
    denyMessage(item) {
      let self = this;
      self.$f7.dialog.preloader();

      self.$store.dispatch('denyChatRoomMessage', {temp_message_id: item.id}).then(() => {
        self.$f7.dialog.close();
        self.getTempMessages();
      }).catch((err) => {
        self.$f7.dialog.close();
        self.$f7.dialog.alert(err, 'LỖI!');
      });
    },
    acceptMessage(item) {
      let self = this;
      self.$f7router.navigate(`/xu-ly/${item.region}/${item.play_style}/khach-hang/${self.customerId}/them-tin-nhan`, {
        props: {
          drawDate: self.$moment(item.drawdate).format('YYYY-MM-DD'),
          message: item.content_original,
          tempMessageId: item.id
        }
      });
    },
    removeBot() {
      let self = this;

      self.$f7.dialog.confirm('Bạn có chắc chắn muốn xóa Bot?', 'THÔNG BÁO!', () => {
        self.$f7.dialog.preloader();

        self.$store.dispatch('removeBotRoom', { room_id: self.chatRoomId }).then(() => {
          self.$f7.dialog.close();
          self.$f7router.back();
        }).catch((err) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert(err, 'LỖI!');
        });
      });
    },
    generateBotRoomCode() {
      let self = this;

      self.$f7.dialog.confirm('Bạn có chắc chắn muốn tạo lại mã liên kết?', 'THÔNG BÁO!', () => {
        self.$f7.dialog.preloader();

        self.$store.dispatch('generateBotRoomCode', { room_id: self.chatRoomId }).then((data) => {
          self.$f7.dialog.close();
          self.connect_code = data.data.data.connect_code;
        }).catch((err) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert(err, 'LỖI!');
        });
      });
    },
    pageMounted(){
      this.tab_active = this.config.allow_active_bot[0];

      let hm = parseInt(moment().tz('Asia/Ho_Chi_Minh').format('HHmm'));

      if (hm >= 1630){
        this.freetext_tab = 'mt';
      } else if (hm >= 1730) {
        this.freetext_tab = 'mb';
      } else {
        this.freetext_tab = 'mn';
      }

      if(this.user_info.user_configs.display_mn){
        this.freetextPlayStyles.mn.push({
          label: 'Sài Gòn',
          value: 'default'
        });
      }
      if(this.user_info.user_configs.display_mn_mtay){
        this.freetextPlayStyles.mn.push({
          label: 'Miền Tây',
          value: 'mn_mtay'
        });
      }
      if(this.user_info.user_configs.display_mn_buonme){
        this.freetextPlayStyles.mn.push({
          label: 'Buôn Mê',
          value: 'mn_buonme'
        });
      }

      if(this.user_info.user_configs.display_mt){
        this.freetextPlayStyles.mt.push({
          label: 'Sài Gòn',
          value: 'default'
        });
      }
      if(this.user_info.user_configs.display_mt_mtay){
        this.freetextPlayStyles.mt.push({
          label: 'Miền Tây',
          value: 'mt_mtay'
        });
      }
      if(this.user_info.user_configs.display_mt_buonme){
        this.freetextPlayStyles.mt.push({
          label: 'Buôn Mê',
          value: 'mt_buonme'
        });
      }

      if(this.user_info.user_configs.display_mb){
        this.freetextPlayStyles.mb.push({
          label: 'Sài Gòn',
          value: 'default'
        });
      }
      if(this.user_info.user_configs.display_mb_mtay){
        this.freetextPlayStyles.mb.push({
          label: 'Miền Tây',
          value: 'mb_mtay'
        });
      }
      if(this.user_info.user_configs.display_mb_buonme){
        this.freetextPlayStyles.mb.push({
          label: 'Buôn Mê',
          value: 'mb_buonme'
        });
      }
      if(this.user_info.user_configs.display_mb_ngan){
        this.freetextPlayStyles.mb.push({
          label: 'Nghệ An',
          value: 'mb_ngan'
        });
      }

      if (this.user_info.server_region === 'hanoi') {
        this.tab_active = 'mb';
        this.tab_overpoint_active = 'mb';
        this.config.allow_active_bot = ['mb'];
        this.play_styles[1].items = [{
          label: 'Hà Nội',
          value: 'mb_hanoi'
        }];

        this.$forceUpdate();
      }

      if (!this._.isUndefined(this.config.allow_active_bot[0])) {
        this.tab_overpoint_active = this.config.allow_active_bot[0];
      }
    },
    pageAfterIn(){
      let self = this;
      self.checkedItems = [];
      if (!_.isUndefined(this.chatRoomId)){
        this.getTempMessages();
        self.intervalMessages = setInterval(function(){
          self.intervalSecond--;
          if (self.intervalSecond === 0){
            self.getTempMessages();
            self.intervalSecond = 10;
          }
        }, 1000);
      }
    },
    pageAfterOut(){
      clearInterval(this.intervalMessages);
    },
    toggleActive(region) {
      let idx = this.config.allow_active_bot.indexOf(region);
      if (idx >= 0) {
        this.config.allow_active_bot.splice(idx, 1);
      }
      else{
        this.config.allow_active_bot.push(region);
      }
      if (!this._.isUndefined(this.config.allow_active_bot[0])) {
        this.tab_overpoint_active = this.config.allow_active_bot[0];
        this.getBlockNumbers();
      }
    },
    toggleAutoConvert() {
      if (this.config.allow_convert_temp_messages.length) {
        this.config.allow_convert_temp_messages = [];
      } else {
        this.config.allow_convert_temp_messages = ['mn', 'mt', 'mb'];
      }
    },
    toggleOverpoint() {
      if (this.config.allow_overpoint_limitation.length) {
        this.config.allow_overpoint_limitation = [];
      }
      else{
        this.config.allow_overpoint_limitation = ['mn', 'mt', 'mb'];
        this.getBlockNumbers();
      }
    },
    toggleCheckbox(item) {
      let idx_checked = this._.findIndex(this.checkedItems, { id: item.id });
      if (idx_checked >= 0) {
        this.checkedItems.splice(idx_checked, 1);
      }
      else{
        this.checkedItems.push(item);
      }
    },
    getBlockNumbers(){
      let self = this;
      if (self.config.allow_overpoint_limitation.length > 0 && self.tab_active === 'config') {
        setTimeout(function() {
          self.$refs.configOverPoint.getBlockNumbers();
        }, 200);
      }
    },
    copyCode() {
      this.$copyText(this.connectCodeCom);
      this.showToastBottom('Đã copy');
    },
    copyClipboard(data) {
      this.$copyText(data);
      this.showToastBottom('Đã copy');
    },
    showToastBottom(text) {
      const self = this;
      if (!self.toastBottom) {
        self.toastBottom = self.$f7.toast.create({
          text: text,
          closeTimeout: 2000,
          position: 'bottom',
          horizontalPosition: 'center'
        });
      }
      self.toastBottom.open();
    },
    goToCreateMessage(){
      if (this.checkedItems.length === 0) {
        this.$f7.dialog.alert('Vui lòng chọn ít nhất 1 tin nhắn!', 'THÔNG BÁO');
        return false;
      }

      let content = '';
      let ids = [];
      this._.each(this.checkedItems, (message, idx) => {
        if (idx > 0) {
          content += '@ ';
        }
        content += message.content_original + "\n";
        ids.push(message.id)
      });

      this.$f7router.navigate(`/xu-ly/${this.freetext_tab}/${this.freetextPlayStyleSelected}/khach-hang/${this.customerId}/them-tin-nhan`, {
        props: {
          drawDate: this.$moment().format('YYYY-MM-DD'),
          message: content,
          tempMessageIds: ids
        }
      });
    }
  }
};
</script>
